export default __webpack_public_path__ + "static/48-83a5c8ea46603f651d4c35787fa5fd40.jpg";